export const DEFAULT_QUERY_STALE_TIME_MS = 1000 * 60 * 60 * 24;
export const DEFAULT_QUERY_GC_TIME_MS = 1000 * 60 * 60 * 24 * 7;
